import { useEffect } from 'react';
import { useStatsigUser as useStatsigUserOriginal } from '@statsig/react-bindings';
import { useUserStore } from '@/hooks/useUserStore';

/**
 * Hook that ensures Statsig user is properly synchronized with app user
 */
export const useStatsigUserSync = () => {
  const { user: appUser } = useUserStore();
  const { updateUserAsync } = useStatsigUserOriginal();
  
  useEffect(() => {
    const expectedUserId = appUser?.userID || 'anonymous';
    
    // Update Statsig user when app user changes
    const updateStatsigUser = async () => {
      await updateUserAsync({ userID: expectedUserId });
    };
    
    updateStatsigUser();
  }, [appUser?.userID, updateUserAsync]);
};
